import { action } from 'typesafe-actions';
import { giftCardActionTypes } from "./types"

export const fetchGiftCard = (data: any) => action(giftCardActionTypes.FETCH_GIFT_CARD, data)

